import { WavePosition, WaveSize } from './types';
import { WavyDivider } from './WavyDivider';
import { WavyEdge as Base } from './WavyEdge';

export * from './types';
export { WavyDivider };

export const WavyEdge = Object.assign(Base, { Divider: WavyDivider, Position: WavePosition, Size: WaveSize });
